import VueCookies from 'vue-cookies';

const TOKEN_KEY = 'accessToken';
const EXPIRE_TOKEN_KEY = 'expiryTokenDate';

const BASE_DOMAIN = `${process.env.VUE_APP_DOMAIN}`;
const STAGE = !process.env.NODE_ENV ? '' : process.env.NODE_ENV;

const TokenService = {

  getExpireTokenDate() {
    return VueCookies.get(`${EXPIRE_TOKEN_KEY}`);
  },

  setExpireTokenDate(expireDate) {
    VueCookies.set(`${EXPIRE_TOKEN_KEY}`, expireDate, null, null, STAGE === 'development' ? null : `.${BASE_DOMAIN}`, STAGE !== 'development');
  },

  removeExpireTokenDate() {
    VueCookies.remove(`${EXPIRE_TOKEN_KEY}`, '/', STAGE === 'development' ? null : `.${BASE_DOMAIN}`);
  },

  getToken() {
    return VueCookies.get(`${TOKEN_KEY}`);
  },

  setToken(accessToken) {
    VueCookies.set(`${TOKEN_KEY}`, accessToken, null, null, STAGE === 'development' ? null : `.${BASE_DOMAIN}`, STAGE !== 'development');
  },

  removeToken() {
    VueCookies.remove(`${TOKEN_KEY}`, '/', STAGE === 'development' ? null : `.${BASE_DOMAIN}`);
  },

};

export { TokenService };
